<template>
  <small :id="`driver-tooltip-target-${_uid}`" class="tag is-abbr-like">
    {{ item.name | limitShow }}
    <tooltip :target="`driver-tooltip-target-${_uid}`" triggers="hover focus" noninteractive custom-class="board-tooltip">
      Telefon: {{ item.phone | phone }}<br>
      Toplam Sefer Sayısı: {{ item.total_transfer_count }}<br>
      Günlük Sefer Sayısı: {{ item.total_daily_transfer_count }}<br>
      Toplam Süre: {{ item.total_transfer_road_time | humanTime }}<br>
      Toplam KM: {{ item.total_transfer_road_distance }}<br>
    </tooltip>
  </small>
</template>
<script>
import { BTooltip as Tooltip } from 'bootstrap-vue'

export default {
  name: 'DriverListItem',
  components: { Tooltip },
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  }
}
</script>
